import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  googleMaps: {
    id: 'jutro-components.widgets.MapArea.GoogleMaps',
    defaultMessage: 'Google Maps'
  }
});